// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1eB_h","paramInput":"JobSimulator_paramInput__34bXZ","input":"JobSimulator_input__234HB"};